import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"

import PointsPartner from "../../containers/points-partner/points-partner"
import PointsRedemptions from "../../containers/points-redemptions/points-redemptions"

/**
 * Routes for third-party Stableford redemption partner accounts (Golf Breaks
 * and any future equivalent).
 *
 * Two pages, and nothing else: the redemption tool their operations team use,
 * and the reconciliation report their finance team pull. Server-side
 * enforcement lives in the `points` Cloud Functions codebase - every callable
 * it exposes re-checks the `is_points_partner` flag on the caller's user
 * document, so narrowing the router is about keeping the account out of
 * surfaces it has no business in, not about being the security boundary.
 */
function PointsPartnerRoutes() {
	return (
		<Switch>
			{/* Exact, or the redemption tool would swallow every path below it */}
			<Route exact path="/points" component={PointsPartner} />
			<Route exact path="/points/redemptions" component={PointsRedemptions} />

			{/* There is nowhere else for this account to be, so every other
			    path lands on the redemption tool rather than a 404 - including
			    the root and the login route they arrive on after signing in. */}
			<Redirect to="/points" />
		</Switch>
	)
}

export default PointsPartnerRoutes
